// * primaries
export const green = '#00FF44';
